import React from "react";
import styled from "styled-components";
import { FlexContainer, Spacing } from "../Containers";
import { ColorClassNames } from "../Colors";
import { baseLength, getMobileBreakpoint } from "../Styles/globals";
import { StyledBaseTile } from "./styles";

/* VERY SIMPLE TILE - Just has an icon and some text */

export const StyledTile = styled(StyledBaseTile)`
  @media (max-width: ${getMobileBreakpoint}) {
    svg {
      width: 30px;
      height: 30px;
    }
    padding: ${`${baseLength * 2.5}px ${baseLength * 2.5}px ${baseLength * 2.5}px ${baseLength * 2.5}px`};
  }
`;

const BaseTile = StyledBaseTile;

export type TileProps = {
  icon?: any;
  text?: string;
  clickable?: boolean;
  onClick?: (...args: any) => any;
  className?: string;
};

const Tile = ({ icon = null, text = "", clickable = true, onClick, className = "" }: TileProps) => (
  <StyledTile data-name={text} className={`tile ${className}`} onClick={onClick} clickable={clickable}>
    <FlexContainer alignItems="center" justifyContent="center">
      {icon}
      {icon && <Spacing row space={baseLength * 3.75} mobileSpace={baseLength * 2.5} />}
      <p className={`medium bold ${ColorClassNames.mint}`}>{text}</p>
    </FlexContainer>
  </StyledTile>
);

export { Tile, BaseTile };
